import { Container, Icon, Tag, Text } from "@fluidattacks/design";
import _ from "lodash";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

const VersionStatus = ({
  outdated,
  vulnerableVersion,
  latestVersion,
}: {
  outdated?: boolean | null;
  vulnerableVersion?: string | null;
  latestVersion?: string | null;
}): ReactElement => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (
    _.isNil(outdated) ||
    _.isNil(vulnerableVersion) ||
    _.isNil(latestVersion)
  ) {
    return (
      <Container>
        <Text
          color={theme.palette.gray[400]}
          fontStyle={"italic"}
          size={"md"}
          wordBreak={"break-word"}
          wordWrap={"normal"}
        >
          {t("searchFindings.tabVuln.notApplicable")}
        </Text>
      </Container>
    );
  }

  return (
    <Container alignItems={"left"} display={"inline-flex"} gap={0.5}>
      {outdated ? (
        <Container display={"inline-flex"} gap={0.5}>
          <Tag
            icon={"calendar-xmark"}
            priority={"low"}
            tagLabel={"Outdated"}
            variant={"warning"}
          />
          <Text size={"md"}>{vulnerableVersion}</Text>
          <Icon
            icon={"arrow-right"}
            iconColor={"#DC6803"}
            iconSize={"lg"}
            iconType={"fa-light"}
          />
          <Text size={"md"}>{latestVersion}</Text>
        </Container>
      ) : (
        <Container display={"inline-flex"} gap={0.5}>
          <Tag
            icon={"calendar-check"}
            priority={"low"}
            tagLabel={"Updated"}
            variant={"success"}
          />
          <Text size={"md"}>{vulnerableVersion}</Text>
        </Container>
      )}
    </Container>
  );
};

const formatVersionStatus = (
  outdated: boolean | undefined | null,
  vulnerableVersion: string | undefined | null,
  latestVersion: string | undefined | null,
): ReactElement => {
  return (
    <VersionStatus
      latestVersion={latestVersion}
      outdated={outdated}
      vulnerableVersion={vulnerableVersion}
    />
  );
};

export { formatVersionStatus };
